import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

export const Radio = ({ title, onClick, light, active }) => (
  <StyledRadio type="button" light={light} onClick={onClick} active={active}>
    {title}
  </StyledRadio>
);

const StyledRadio = styled.button`
  margin-top: var(--sp-2);
  color: ${(props) => (props.active ? 'var(--white)' : 'var(--red)')};
  border: 1px solid ${(props) => (props.active ? 'var(--white)' : 'var(--red)')};
  background: ${(props) =>
    props.active ? 'var(--red)' : 'var(--transparent)'};
  font-size: 16px;
  padding: 0 var(--sp-2);
  border-radius: 120px;
  height:32px;
  transition: 0.3s;
  margin-right: 1.6rem;

  &:hover {
    border-color: ${(props) => (props.light ? 'var(--white)' : 'var(--red)')};
    background: ${(props) => (props.light ? 'var(--white)' : 'var(--red)')};
    color: ${(props) => (props.light ? 'var(--red)' : 'var(--white)')};
  }
`;

Radio.propTypes = {
  title: PropTypes.string,
  light: PropTypes.bool,
};
